import FinishFlag from "@/assets/states/FinishFlag";
import React from "react";

const Complete = () => {
	return (
		<div className="flex flex-col justify-start items-center px-6 text-left">
			<h3 className="mx-auto font-semibold text-slate-950 text-xl">
				Diary Complete! 🎉
			</h3>
			<p className="mt-2 text-slate-700">
				Thank you for completing your diary. No further action is
				required. Your responses have been saved and will help your care
				team.
			</p>
		</div>
	);
};

export default Complete;
